import type { IQuizRepository } from '@/core/domain/quiz/IQuizRepository.ts'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'
import type { QuizVersion } from '@/core/domain/quiz/QuizVersion.ts'

export class UpdateQuizVersionUseCase {
  private quizRepository: IQuizRepository

  constructor(quizRepository: IQuizRepository) {
    this.quizRepository = quizRepository
  }

  async execute(quizId: number, version: QuizVersion): Promise<Quiz> {
    // Mettre à jour la version
    await this.quizRepository.updateQuizVersion(quizId, version)

    // Récupérer le quiz complet mis à jour
    return await this.quizRepository.fetchQuiz(quizId)
  }
}
